import React from "react";
import Modal from "react-modal";

import { triplePSDatasource } from "../../../datasource";

import "./ReceiptModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    maxWidth: "640px",
    width: "90%",
    maxHeight: "85vh",
    padding: "0",
  },
};

interface Props {
  receiptId: string | null;
  onClose: () => void;
}

// Fetches and displays a dump receipt photo. The backend returns the image as a
// base64 JPEG (see getDumpEventReceipt); a fetch failure (e.g. no receipt stored)
// shows a message rather than a broken image.
export function ReceiptModal({ receiptId, onClose }: Props) {
  const [src, setSrc] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  // Click-to-zoom: toggles the image between fit-to-modal and natural size
  // (the modal body scrolls to pan). Reset whenever a new receipt loads.
  const [zoomed, setZoomed] = React.useState(false);

  React.useEffect(() => {
    if (!receiptId) return;
    let cancelled = false;
    setLoading(true);
    setError(false);
    setSrc(null);
    setZoomed(false);
    triplePSDatasource
      .getDumpEventReceipt(receiptId)
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [receiptId]);

  return (
    <Modal
      isOpen={receiptId !== null}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel="Dump receipt"
    >
      <div className="receipt-modal">
        <div className="receipt-modal-header">
          <h3>Dump receipt</h3>
          <button
            className="receipt-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="receipt-modal-body">
          {loading && (
            <div className="receipt-modal-loading">Loading receipt…</div>
          )}
          {error && (
            <div className="receipt-modal-error">No receipt available.</div>
          )}
          {src && (
            <img
              src={src}
              alt="Dump receipt"
              className={`receipt-modal-img ${zoomed ? "zoomed" : ""}`}
              title={zoomed ? "Click to zoom out" : "Click to zoom in"}
              onClick={() => setZoomed((z) => !z)}
            />
          )}
        </div>
      </div>
    </Modal>
  );
}
